import type { AppState } from '../../store/types';
import type { ObjectWithId } from '../../types/common';
import type { GetDefinition } from './types';

export const isContextMenuEmpty = <
  Item extends ObjectWithId = ObjectWithId,
  State = AppState,
>(
  getDefinition: GetDefinition<Item, State>,
  state: State,
  contextItems: Item[] = [],
) =>
  getDefinition(
    {
      contextItems,
      options: undefined,
    },
    state,
  ).items.length === 0;

export const getCreateCollectionActionLabel = (collectionId?: string): string =>
  `Create New ${collectionId ? 'Subcollection' : 'Collection'}…`;
